import { SameSiteTypes } from "../services";

// Default values for reuse. However, they can't be used in properties initial definitions (e.g. `consentLifetimeAccepted`)
// as they would not be compiled into the docs (readme.md). If you need default values for reuse, put them here.
export const defaultValues = {
	consentLifetimeAccepted: 365,
	consentLifetimeDeclined: 60,
	cookieSameSite: "Lax" as SameSiteTypes,
	siteTypesList: ["strict", "Strict", "lax", "Lax", "none", "None"],
	linksTarget: "_self",
};
